import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  headerText: {
    color: codGray,
    fontSize: 16,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
  showHideButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: indent,
  },
  showHideButton: {
    color: denim,
    marginRight: indent * 0.5,
    fontWeight: '600',
  },
  icon: {
    fontSize: 18.5,
    fontWeight: '600',
    alignSelf: 'flex-end',
  },
  container: {
    marginBottom: 0,
    marginTop: indent * 2.0,
    marginHorizontal: indent * 0.75,
  },
  tabContainerStyle: {
    marginTop: 0,
    overflow: 'hidden' as const,
    position: 'relative' as const,
  },
  sceneContainerStyle: {
    paddingTop: 0,
  },
  tabLoader: {
    marginTop: indent * 4,
  },
  loader: {
    marginTop: indent,
  },
  featureFeedback: {
    marginTop: 10,
  },
});
